import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, type AppCheck } from "firebase/app-check";
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const currentHostname = typeof window === "undefined" ? "" : window.location.hostname;
const authDomain = ["dickerticker.com", "www.dickerticker.com"].includes(currentHostname)
  ? currentHostname
  : "dickerticker-2026.firebaseapp.com";

const firebaseConfig = {
  projectId: "dickerticker-2026",
  appId: "1:481505823812:web:c008f845d17b5782624011",
  storageBucket: "dickerticker-2026.firebasestorage.app",
  apiKey: "AIzaSyB8_2LJcHGNkFZvmCe9Geas8YXzKsdoJP0",
  authDomain,
  messagingSenderId: "481505823812",
};

export const firebaseApp = initializeApp(firebaseConfig);

const usingEmulators = import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true";

if (import.meta.env.DEV && !usingEmulators) {
  (self as typeof self & { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

let appCheck: AppCheck | undefined;

export function initializeProtection() {
  if (usingEmulators || appCheck) return appCheck;

  appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider("6LfrQN8tAAAAAEL6gINiF14DU4wBNjfN9R1MAH67"),
    isTokenAutoRefreshEnabled: true,
  });

  return appCheck;
}

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp, "us-central1");
export const storage = getStorage(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

if (usingEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}
